import React, { useContext, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  Dropdown,
  InputGroup,
  Spinner,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFilter, faCalendarAlt, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../UnmarketableTickets";
import { includesSearchText } from "../../../../helper/text";
import { useCookies } from "react-cookie";
import { exportAll } from "../../../../controller/api/__classic__/unmarketable-tickets";
import { exportUnmarketableTicketsToExcel } from "../../../../helpers/excelExport";

const FilterForm = () => {
  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);

  const [fromDate, setFromDate] = useState(state.filter.fromDate);
  const [toDate, setToDate] = useState(state.filter.toDate);
  const [channelId, setChannelId] = useState(state.filter.channelId);
  const [rewardCalculated, setRewardCalculated] = useState(
    state.filter.rewardCalculated,
  );
  const [winningStatus, setWinningStatus] = useState(
    state.filter.winningStatus,
  );
  const [channelSearch, setChannelSearch] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const filteredChannels = channelSearch
    ? state.channels.filter((channel) =>
        includesSearchText(channel.name, channelSearch),
      )
    : state.channels;

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        fromDate,
        toDate,
        channelId,
        rewardCalculated,
        winningStatus,
      },
    });
  };

  const handleExportExcel = async () => {
    setIsExporting(true);
    try {
      const query = {
        fromDate: state.filter.fromDate || undefined,
        toDate: state.filter.toDate || undefined,
        channelId: state.filter.channelId,
        rewardCalculated: state.filter.rewardCalculated,
        winningStatus: state.filter.winningStatus,
      };

      const response = await exportAll(cookies.lottmekong, query);
      if (response && response.data) {
        exportUnmarketableTicketsToExcel(response.data, state.summary, state.filter);
      }
    } catch (error) {
      console.error('Export failed:', error);
      alert('Xuất Excel thất bại. Vui lòng thử lại!');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Card border="light" className="shadow-sm border-0">
      <Card.Body className="p-3">
        <div className="d-flex align-items-center mb-3">
          <div className="icon icon-shape icon-sm shadow-sm border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
            <FontAwesomeIcon icon={faFilter} className="text-primary" />
          </div>
          <h6 className="mb-0">Vé ế</h6>
        </div>

        <Form onSubmit={onSubmit}>
          <Row className="g-3 align-items-end">
            <Col xs={12} md={6} xl={2}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Từ ngày</Form.Label>
              <InputGroup className="input-group-merge">
                <InputGroup.Text className="bg-white border-end-0">
                  <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  className="border-start-0 ps-0"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                  style={{ cursor: "pointer" }}
                />
              </InputGroup>
            </Col>

            <Col xs={12} md={6} xl={2}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đến ngày</Form.Label>
              <InputGroup className="input-group-merge">
                <InputGroup.Text className="bg-white border-end-0">
                  <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  className="border-start-0 ps-0"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                  style={{ cursor: "pointer" }}
                />
              </InputGroup>
            </Col>

            <Col xs={12} md={6} xl={2}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đài</Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle
                  variant="white"
                  className="w-100 text-start d-flex align-items-center justify-content-between form-control bg-white border"
                  id="dropdown-channel-select"
                >
                  <span className="text-truncate">
                    {channelId && channelId !== "all"
                      ? state.channels.find(
                          (ch) => String(ch.id) === String(channelId),
                        )?.name || "Tất cả"
                      : "Tất cả"}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="w-100 p-2 shadow-sm"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  <div className="px-1 mb-2 sticky-top bg-white">
                    <InputGroup>
                      <InputGroup.Text className="bg-white border-end-0">
                        <FontAwesomeIcon
                          icon={faSearch}
                          className="text-muted"
                        />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        placeholder="Tìm đài..."
                        value={channelSearch}
                        onChange={(e) => setChannelSearch(e.target.value)}
                        className="bg-white border-start-0 ps-0"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </InputGroup>
                  </div>

                  <Dropdown.Item
                    active={channelId === "all" || channelId === ""}
                    onClick={() => {
                      setChannelId("all");
                      setChannelSearch("");
                    }}
                    className="rounded-2"
                  >
                    Tất cả
                  </Dropdown.Item>

                  {filteredChannels.length > 0 ? (
                    filteredChannels.map((channel) => (
                      <Dropdown.Item
                        key={channel.id}
                        active={String(channelId) === String(channel.id)}
                        onClick={() => {
                          setChannelId(channel.id);
                          setChannelSearch("");
                        }}
                        className="rounded-2"
                      >
                        {channel.name}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <div className="text-center text-muted small py-2">
                      Không tìm thấy đài
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col xs={12} md={6} xl={3}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Tính thưởng</Form.Label>
              <Form.Select
                value={rewardCalculated}
                onChange={(e) => setRewardCalculated(e.target.value)}
                className="bg-white"
              >
                <option value="all">Tất cả</option>
                <option value="calculated">Đã tính</option>
                <option value="not_calculated">Chưa tính</option>
              </Form.Select>
            </Col>

            <Col xs={12} md={6} xl={3}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Trúng thưởng</Form.Label>
              <Form.Select
                value={winningStatus}
                onChange={(e) => setWinningStatus(e.target.value)}
                className="bg-white"
              >
                <option value="all">Tất cả</option>
                <option value="won">Trúng</option>
                <option value="not_won">Không trúng</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col xs={12} className="d-flex justify-content-end gap-2">
              <Button
                variant="primary"
                type="submit"
                className="shadow-sm"
                disabled={state.isLoading}
              >
                {state.isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang tải...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    Tìm kiếm
                  </>
                )}
              </Button>
              <Button
                variant="success"
                type="button"
                className="shadow-sm"
                disabled={isExporting || state.isLoading}
                onClick={handleExportExcel}
              >
                {isExporting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang xuất...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                    Xuất Excel
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default React.memo(FilterForm);
